var React = require('react');

function Bell (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m22.5001 13.75c0-3.8375-2.05-7.05-5.625-7.9v-.85c0-1.0375-.8375-1.875-1.875-1.875s-1.875.8375-1.875 1.875v.85c-3.5875.85-5.625 4.05-5.625 7.9v6.25l-2.5 2.5v1.25h20v-1.25l-2.5-2.5zm-14.8125-10.4375 1.7875 1.7875c-2.55 1.8125-4.25 4.7125-4.4375 8.025h-2.5c.175-4 2.15-7.525 5.15-9.8125zm19.775 9.8125h-2.5c-.1875-3.3125-1.9-6.2125-4.425-8.025l1.775-1.7875c2.9875 2.2875 4.9625 5.8125 5.15 9.8125zm-11.9625 14.325c-.1625.0375-.325.05-.5.05-1.3875 0-2.5-1.125-2.5125-2.5h5c0 .35-.0625.675-.1875.975-.325.75-.9875 1.3-1.8 1.475z","fill":"#3d278a","fillRule":"evenodd"}));
}

Bell.defaultProps = {"fill":"none","height":"30","viewBox":"0 0 30 30","width":"30"};

module.exports = Bell;

Bell.default = Bell;
